import Vue from 'vue';
import Vuex from 'vuex';
import pathify from 'vuex-pathify';

import authentication from '@/store/authentication';
import featuresData from '@/store/featuresData';
import map from '@/store/map';
import snackbar from '@/store/snackbar';
import tools from '@/store/tools';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [pathify.plugin],
  modules: { authentication, featuresData, map, snackbar, tools },
});
